module.exports = __webpack_public_path__ + "img/oo.593ba6f9.gif";